export default "__VITE_ASSET__DFKzTbHf__"